import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function NavBar() {
  const { user, logout } = useAuth();
  const navigate         = useNavigate();
  const location         = useLocation();
  const [time, setTime]  = useState(new Date());

  useEffect(() => {
    const t = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const isActive = (path) => location.pathname === path;

  const navStyle = {
    background:     'linear-gradient(180deg, #0A1628 0%, #0D1B2A 100%)',
    borderBottom:   '1px solid #1E3050',
    padding:        '0 24px',
    display:        'flex',
    alignItems:     'center',
    justifyContent: 'space-between',
    height:         '56px',
    position:       'sticky',
    top:            0,
    zIndex:         100,
  };

  const logoStyle = {
    fontFamily:  'Rajdhani, sans-serif',
    fontSize:    '20px',
    fontWeight:  700,
    color:       '#C9A84C',
    letterSpacing: '0.12em',
    cursor:      'pointer',
  };

  const linkStyle = (active) => ({
    fontFamily:   'Rajdhani, sans-serif',
    fontSize:     '14px',
    fontWeight:   600,
    letterSpacing: '0.08em',
    color:        active ? '#C9A84C' : '#8896A8',
    cursor:       'pointer',
    padding:      '4px 12px',
    borderRadius: '4px',
    background:   active ? 'rgba(201,168,76,0.08)' : 'transparent',
    border:       active ? '1px solid rgba(201,168,76,0.2)' : '1px solid transparent',
    transition:   'all 0.2s',
    textDecoration: 'none',
  });

  const timeStyle = {
    fontFamily:  'JetBrains Mono, monospace',
    fontSize:    '12px',
    color:       '#C9A84C',
    letterSpacing: '0.05em',
  };

  return (
    <nav style={navStyle}>
      {/* Logo */}
      <div style={logoStyle} onClick={() => navigate('/dashboard')}>
        FX CAPITAL INDIA
      </div>

      {/* Links */}
      <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
        <span
          style={linkStyle(isActive('/dashboard'))}
          onClick={() => navigate('/dashboard')}>
          LIVE RATES
        </span>
        <span
          style={linkStyle(isActive('/forward-rates'))}
          onClick={() => navigate('/forward-rates')}>
          FORWARD RATES
        </span>
        {user?.isAdmin && (
          <span
            style={linkStyle(isActive('/admin'))}
            onClick={() => navigate('/admin')}>
            ADMIN
          </span>
        )}
      </div>

      {/* Right side */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
        <div style={timeStyle}>
          {time.toLocaleTimeString('en-IN', {
            hour: '2-digit', minute: '2-digit', second: '2-digit',
            hour12: false
          })}
        </div>
        <div style={{ color: '#8896A8', fontSize: '12px' }}>
          {user?.fullName}
        </div>
        <button
          onClick={handleLogout}
          style={{
            background:    'transparent',
            border:        '1px solid #1E3050',
            color:         '#8896A8',
            padding:       '4px 12px',
            borderRadius:  '4px',
            cursor:        'pointer',
            fontFamily:    'Rajdhani, sans-serif',
            fontSize:      '13px',
            fontWeight:    600,
            letterSpacing: '0.06em',
            transition:    'all 0.2s',
          }}
          onMouseOver={e => {
            e.target.style.borderColor = '#EF4444';
            e.target.style.color = '#EF4444';
          }}
          onMouseOut={e => {
            e.target.style.borderColor = '#1E3050';
            e.target.style.color = '#8896A8';
          }}>
          LOGOUT
        </button>
      </div>
    </nav>
  );
}